<template>
    <div id="concurso">
        <div class="height-700 height-180 bg-cover bg-center" :style="`background-image: url(${data.imagem.url})`">
        </div>
        <div class="container bg-white header-concurso">
            <div class="row justify-content-center pt-xl-4 pt-3">
                <div class="col-xl-7 pb-4">
                    <div class="font-glacial-bold font-30 text-uppercase text-xl-left text-center pb-3">
                        <h1 class="mt-4 mb-3 font-glacial-bold font-30 text-uppercase text-xl-left text-center">
                            {{data.titulo}}
                        </h1>
                    </div>
                    <div class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                        <h2 class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                            {{data.subtitulo}}
                        </h2>
                    </div>
                </div>
                <div class="col-xl-3 pb-xl-4 d-flex justify-content-end align-items-end">
                    <div class="send-icon d-none d-xl-block">
                    </div>
                </div>
            </div>
            <form>
            <div class="row justify-content-center pb-4 pb-xl-5">
                <div class="col-xl-5">
                    <div class="pt-4 input-group">
                        <span class="input-group-addon">
                            <div class="icon person-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input"
                            v-model="form.nome" 
                            type="text" 
                            placeholder="SEU NOME" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='SEU NOME'"
                        />
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.nome">
                        {{errors.nome[0].message}}
                    </div>
     
                    <div class="pt-5 input-group">
                        <span class="input-group-addon">
                            <div class="icon email-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input"
                            v-model="form.email" 
                            type="text" 
                            placeholder="exemplo@exemplo.com.br" 
                            onfocus="this.placeholder=''" 
                            onblur="this.placeholder='exemplo@exemplo.com.br'" 
                        />
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.email">
                        {{errors.email[0].message}}
                    </div>
                    
                    <div class="pt-4 input-group">
                        <span class="input-group-addon">
                            <div class="icon curso-icon" style="position: absolute; margin-top: 8px;"></div>
                        </span>
                        <multiselect 
                            class="form-control form-field borda-curso padding-input"
                            placeholder="CURSO"
                            label="nome"
                            trackBy="nome"
                            v-model="form.idscursos"
                            :options="cursos"
                            :multiple="true"
                            :searchable="true"
                            :close-on-select="true"
                             style="height: auto;"
                        ></multiselect>
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.idscursos">
                        {{errors.idscursos[0].message}}
                    </div>

                </div>
                <div class="col-xl-5 mt-4 mt-md-0">

                    <div class="pt-4 input-group">
                        <span class="input-group-addon">
                            <div class="icon phone-icon"></div>
                        </span>
                        <b-form-input class="form-control form-field padding-input"
                            v-model="form.telefone"
                            v-mask="'(##) #####-####'"
                            type="tel" 
                            placeholder="CELULAR" 
                        />
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.telefone">
                        {{errors.telefone[0].message}}
                    </div>
                
                    <div class="pt-5 input-group">
                        <span class="input-group-addon">
                            <div class="icon calendar-icon"></div>
                        </span>
                        <b-form-input
                            v-model="form.data_nascimento"
                            v-mask="'##/##/####'"
                            type="tel" 
                            placeholder="DATA DE NASCIMENTO" 
                            class="form-control form-field padding-input">
                        </b-form-input>
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.data_nascimento">
                        {{errors.data_nascimento[0].message}}
                    </div>
                    <div class="pt-4">
                        <multiselect class="form-control form-field borda-curso"
                            placeholder="ESCOLA BAUHAUS"
                            label="value"
                            v-model="form.assunto"
                            :options="assuntos"
                            :multiple="false"
                            :searchable="true"
                            :close-on-select="true"
                            :allow-empty="false"
                        ></multiselect>
                    </div>
                    <div class="text-center text-error-msg" v-if="errors && errors.bauhaus">
                        {{errors.bauhaus[0].message}}
                    </div>
                </div>

                <div class="pt-5">
                    <b-alert show variant="success" v-if="success">
                        {{success}}
                    </b-alert>
                    <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.message">
                        {{errors.message}}
                    </b-alert>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-xl-5 mb-4 pb-xl-4">
                    <div class="font-glacial-regular font-16 text-gray-light text-xl-left text-center">
                        {{data.mensagem}}
                    </div>
                </div>
                <div class="col-xl-5 mb-4 pb-xl-4 align-items-center">
                    <div class="d-flex justify-content-xl-end justify-content-center">
                        <div>
                            <b-btn type="button" class="btn btn-enviar btn-pointer btn-opacidade" @click="submit" :disabled="loading">
                                <span v-if="!loading">ENVIAR</span>
                                <span v-else>ENVIANDO ...</span>
                            </b-btn>
                        </div>
                    </div>
                </div>
            </div>
            </form>
            <div class="row mt-4 pt-xl-3 justify-content-center">
                <div class="col-xl-5 col-lg-5 col-md-5 mb-4 pb-4" v-for="(d, index) in data.localizacao" :key="index">
                    <div class="row align-items-center font-glacial-bold font-24 mb-3">
                        <div class="col-1">
                            <div class="location-icon"></div>
                        </div>
                        <div class="ml-1 ml-xl-0">
                            {{d.cidade}}
                        </div>
                    </div>
                    <a v-bind:href="d.link">
                        <div class="font-glacial-regular font-16 text-gray-light">
                            {{d.endereco}}
                        </div>
                        <div class="bg-line">
                        </div>
                        <div class="font-glacial-regular font-16 text-gray-light">
                            {{d.telefone}}
                        </div>
                        <div class="font-glacial-regular font-16 text-gray-light">
                            {{d.email}}
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
export default {
    props:{
        data: null
    },
    components: {Multiselect},
    // components: { Multiselect }

    data(){
        return{
            success: null,
            errors: null,
            loading: false,
            assuntos: [
                { id: 1, value: 'Ribeirão Preto - SP' },
                { id: 2, value: 'Piracicaba - SP' } 
            ],
            form:{
                nome: '',
                email: '',
                telefone: '',
                idscursos: '',
                campanha: '',
                assunto: '',
                data_nascimento: '',
            }
        }
    },
    methods:{
        showError(field){
            if(this.errors && this.errors.invalidFields){

                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return e.message
                    }
                }
            }

            return null;
        },
        async serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        async submit(){
            if (this.errors && this.errors.message) {
                this.errors.message = null
            }

            this.loading = true
            this.errors  = null

            var arrForm = Object.assign({}, this.form);

            if (this.form.assunto && this.form.assunto.id > 0) {
                arrForm.bauhaus = this.form.assunto.id
            } else {
                arrForm.bauhaus = '';
            }

            if (this.form.idscursos) {
                var arrAux = [];
                for (var i = 0; i < this.form.idscursos.length; i++) {
                    arrAux.push(this.form.idscursos[i].id)
                }
                arrForm.idscursos = arrAux.join(',');
            }

            delete arrForm.assunto;
            delete arrForm.campanha;
            var query = await this.serialize(arrForm);
            
            try {
                var response = await axios.get('http://manager.escolabauhaus.com.br/concurso-de-bolsas/inscricao/get?' + query);
                
                if (response.data && response.data != 1) {
                    this.errors = response.data
                } else if (response.data == 1) {
                    this.form.nome = ''
                    this.form.email = '' 
                    this.form.telefone = '' 
                    this.form.idscursos = [] 
                    this.form.campanha = ''
                    this.form.assunto = ''
                    this.form.data_nascimento = ''
                    this.success = 'Formulário enviado com sucesso'
                }
            } catch (e) {
                console.log(e)
            }
            
            this.loading = false
            
            return false;
        }
    },
    computed: {
        cursos(){
            if (!this.$store.state.post.cursosApi) {
                return []
            }

            return this.$store.state.post.cursosApi.filter(e => e.concurso_bolsas == 'True')
        },
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .borda-curso .multiselect__tags{
        border: none !important;
    }

    .multiselect {
        height: 35px;
        min-height: 35px;
    }
</style>


// WEBPACK FOOTER //
// src/components/widgets/header_concurso.vue